'use client';

import Accordion from '@carvana/ds-accordion';
import { faqItems } from '~/constants/dealership/testDriveCenter/content';

export default function TestDriveCenterFaq() {
  return (
    <section className="bg-canvas-default px-2xl py-6xl md:px-3xl md:py-7xl lg:px-4xl">
      <div className="mx-auto grid max-w-[1272px] grid-cols-1 gap-3xl lg:grid-cols-[408px_1fr] lg:gap-[88px]">
        <h2 className="text-text-strong t-heading-2xl md:t-heading-3xl">
          Frequently asked questions
        </h2>
        <div className="flex flex-col">
          {faqItems.map(item => (
            <Accordion
              key={item.question}
              classes={{ container: 'py-0', header: 'py-2xl' }}
              dataAttr={{
                header: {
                  'data-analytics-id': `Test Drive Center - FAQ - ${item.question}`
                }
              }}
              toggleStyle="plus-minus"
              headerText={item.question}
              testId={`test-drive-center-faq-${item.question
                .slice(0, 20)
                .replace(/\s+/g, '-')
                .toLowerCase()}`}
            >
              <p className="max-w-[680px] pb-2xl text-text-default t-body-md">
                {item.answer}
              </p>
            </Accordion>
          ))}
        </div>
      </div>
    </section>
  );
}
